export default __webpack_public_path__ + "static/media/true_v.9dcead3e.png";